import { AuthRedirectViewRedesigned } from "./AuthRedirectViewRedesigned";
import { EmailInputView } from "./EmailInputView";
import { type AuthState } from "./types";

interface AuthRedirectViewProps {
  authState: AuthState;
  error?: string;
  existingEmail?: string;
  magicLinkEmail?: string | null;
  /** Custom-scheme URL to open the native app. Shown on mobile browsers where Universal Links failed. */
  appSchemeUrl?: string;
  emailInputError?: string;
  onContinue: () => void;
  onSignOutAndContinue: () => void;
  onSubmitEmail: (email: string) => void;
  onGoToDashboard: () => void;
}

export function AuthRedirectView(props: AuthRedirectViewProps) {
  // Route the verify-email prompt outside the redesigned view so it doesn't
  // have to carry its own copy of the form, props, and case branch.
  // Destructure first so `authState` narrows after the early return and
  // `viewProps` matches the inner view's narrower interface.
  const { authState, emailInputError, onSubmitEmail, ...viewProps } = props;

  if (authState === "email-input") {
    return (
      <EmailInputView
        emailInputError={emailInputError}
        appSchemeUrl={viewProps.appSchemeUrl}
        onSubmitEmail={onSubmitEmail}
      />
    );
  }

  return <AuthRedirectViewRedesigned {...viewProps} authState={authState} />;
}
